/*
 * Copyright (C) 2005 - 2023. Cloud Software Group, Inc. All Rights Reserved. Confidential & Proprietary.
 * Licensed pursuant to commercial Cloud Software Group, Inc. End User License Agreement.
 */

import addWebPageViewDialogContentTemplate from '../template/addWebPageViewDialogContentTemplate.htm';
import addTextDialogContentTemplate from '../template/addTextDialogContentTemplate.htm';
import addImageDialogContentTemplate from '../template/addImageDialogContentTemplate.htm';
import addAdHocViewDialogContentTemplate from '../template/addAdHocViewDialogContentTemplate.htm';
import basePropertiesDialogTemplate from '../template/properties/basePropertiesDialogTemplate.htm';
import dashboardComponentTypes from '../enum/dashboardComponentTypes';

var templateByType = {};
templateByType[dashboardComponentTypes.WEB_PAGE_VIEW] = addWebPageViewDialogContentTemplate;
templateByType[dashboardComponentTypes.FREE_TEXT] = addTextDialogContentTemplate;
templateByType[dashboardComponentTypes.IMAGE] = addImageDialogContentTemplate;
templateByType[dashboardComponentTypes.ADHOC_VIEW] = addAdHocViewDialogContentTemplate;
templateByType[dashboardComponentTypes.TABLE] = addAdHocViewDialogContentTemplate;
templateByType[dashboardComponentTypes.CHART] = addAdHocViewDialogContentTemplate;
templateByType[dashboardComponentTypes.CROSSTAB] = addAdHocViewDialogContentTemplate;

export default function (model) {
    var type;
    var template = (type = model.get('type')) in templateByType ? templateByType[type] : basePropertiesDialogTemplate;
    return template;
}